export default "__VITE_ASSET__B4yG_4Wc__"